/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeftDown: {
  name: 'arrow-left-down';
  data: string;
} = {
  name: 'arrow-left-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.707 6.293a1 1 0 0 1 0 1.414L9.414 16H15a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v5.586l8.293-8.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
